import initSubjectLinePicker from "../../../utils/subject-line-picker";

var moment = require('moment');

(function () {
    angular.module('active-send-email-action.dir', [])
        .directive('activeSendEmailAction', ['$rootScope', '$compile', '$templateCache', 'helpers', 'canvasService', '$stateParams', '$timeout', '$q', '$document', 'Session', activeSendEmailAction]);

    function activeSendEmailAction($rootScope, $compile, $templateCache, helpers, canvasService, $stateParams, $timeout, $q, $document, Session) {
        return {
            scope: {},
            controller: ['$scope', function ($scope) {
                let timezones = [
                    { value:'ADT', offset:'-0300', label: '(US) Atlantic Daylight'},
                    { value:'AST', offset:'-0400', label: '(US) Atlantic Standard'},
                    { value:'AT', offset:'-0400', label: '(US) Atlantic'},
                    { value:'CDT', offset:'-0500', label: '(US) Central Daylight'},
                    { value:'CST', offset:'-0600', label: '(US) Central Standard'},
                    { value:'CT', offset:'-0600', label: '(US) Central'},
                    { value:'EDT', offset:'-0400', label: '(US) Eastern Daylight'},
                    { value:'EST', offset:'-0500', label: '(US) Eastern Standard'},
                    { value:'ET', offset:'-0500', label: '(US) Eastern'},
                    { value:'MDT', offset:'-0600', label: '(US) Mountain Daylight'},
                    { value:'MST', offset:'-0700', label: '(US) Mountain Standard'},
                    { value:'MT', offset:'-0700', label: '(US) Mountain'},
                    { value:'PDT', offset:'-0700', label: '(US) Pacific Daylight'},
                    { value:'PST', offset:'-0800', label: '(US) Pacific Standard'},
                    { value:'PT', offset:'-0800', label: '(US) Pacific'},
                    { value:'ACDT', offset:'+1030', label: 'Australian Central Daylight'},
                    { value:'ACST', offset:'+0930', label: 'Australian Central Standard'},
                    { value:'AEDT', offset:'+1100', label: 'Australian East Daylight'},
                    { value:'AEST', offset:'+1000', label: 'Australian East Standard'},
                    { value:'SAD', offset:'+1000', label: 'Australian South Daylight'},
                    { value:'SAST', offset:'+0900', label: 'Australian South Standard'},
                    { value:'AWDT', offset:'+0900', label: 'Australian West Daylight'},
                    { value:'AWST', offset:'+0800', label: 'Australian West Standard'},
                    { value:'BT', offset:'+0300', label: 'Baghdad'},
                    { value:'BET', offset:'-1100', label: 'Bering Standard'},
                    { value:'BZT2', offset:'-0300', label: 'Brazil Zone 2'},
                    { value:'BDST', offset:'+0200', label: 'British Double Summer'},
                    { value:'BST', offset:'+0100', label: 'British Summer Time'},
                    { value:'CAT', offset:'-1000', label: 'Central Alaska'},
                    { value:'CED', offset:'+0200', label: 'Central European Daylight'},
                    { value:'CCT', offset:'+0800', label: 'China Coast'},
                    { value:'HKT', offset:'+0800', label: 'Hong Kong Time'},
                    { value:'SGT', offset:'+0800', label: 'Singapore Time'},
                    { value:'MYT', offset:'+0800', label: 'Malaysia Time'},
                    { value:'CAF', offset:'+0200', label: 'Central Africa Time'},
                    { value:'CET', offset:'+0100', label: 'Central European'},
                    { value:'CEST', offset:'+0200', label: 'Central European Summer'},
                    { value:'EED', offset:'+0300', label: 'Eastern European Daylight'},
                    { value:'EET', offset:'+0200', label: 'Eastern Europe'},
                    { value:'EEST', offset:'+0300', label: 'Eastern Europe Summer'},
                    { value:'MED', offset:'+0200', label: 'European Middle Daylight'},
                    { value:'MET', offset:'+0100', label: 'European Middle'},
                    { value:'MEST', offset:'+0200', label: 'European Middle Summer'},
                    { value:'MEWT', offset:'+0100', label: 'European Middle Winter'},
                    { value:'FST', offset:'+0200', label: 'French Summer'},
                    { value:'FWT', offset:'+0100', label: 'French Winter'},
                    { value:'GMT', offset:'-0000', label: 'Greenwich Mean'},
                    { value:'GMT', offset:'+0000', label: 'Greenwich Mean'},
                    { value:'GST', offset:'+1000', label: 'Guam Standard'},
                    { value:'HDT', offset:'-0900', label: 'Hawaii Daylight'},
                    { value:'HST', offset:'-1000', label: 'Hawaii Standard'},
                    { value:'IDLE', offset:'+1200', label: 'Internation Date Line East'},
                    { value:'IDLW', offset:'-1200', label: 'Internation Date Line West'},
                    { value:'IST', offset:'+0530', label: 'Indian Standard'},
                    { value:'IT', offset:'+0330', label: 'Iran'},
                    { value:'JST', offset:'+0900', label: 'Japan Standard'},
                    { value:'JT', offset:'+0700', label: 'Java'},
                    { value:'PMDT', offset:'-0200', label: 'Mid-Atlantic'},
                    { value:'NDT', offset:'-0230', label: 'Newfoundland Daylight'},
                    { value:'NFT', offset:'-0330', label: 'Newfoundland'},
                    { value:'NT', offset:'-1100', label: 'Nome'},
                    { value:'NST', offset:'+0630', label: 'North Sumatra'},
                    { value:'NZST', offset:'+1200', label: 'New Zealand Standard'},
                    { value:'NZDT', offset:'+1300', label: 'New Zealand Daylight '},
                    { value:'ROK', offset:'+0900', label: 'Republic of Korea'},
                    { value:'SST', offset:'+0200', label: 'Swedish Summer'},
                    { value:'SWT', offset:'+0100', label: 'Swedish Winter'},
                    { value:'USZ3', offset:'+0400', label: 'USSR Zone 3'},
                    { value:'USZ4', offset:'+0500', label: 'USSR Zone 4'},
                    { value:'USZ5', offset:'+0600', label: 'USSR Zone 5'},
                    { value:'USZ6', offset:'+0700', label: 'USSR Zone 6'},
                    { value:'UTC', offset:'-0000', label: 'Universal Coordinated'},
                    { value:'UZ10', offset:'+1100', label: 'USSR Zone 10'},
                    { value:'WAT', offset:'-0100', label: 'West Africa'},
                    { value:'WET', offset:'-0000', label: 'West European'},
                    { value:'YDT', offset:'-0800', label: 'Yukon Daylight'},
                    { value:'YST', offset:'-0900', label: 'Yukon Standard'}
                ];

                const lang = Session.getCookie('L');
                $scope.faqHelpLink = {
                    english: 'https://kb.benchmarkemail.com/can-i-add-google-analytics-tracking-to-my-email-campaigns/',
                    spanish: 'https://kb.benchmarkemail.com/es/puedo-agregar-seguimiento-de-google-analytics-a-mis-campanas-de-correo-electronico/',
                    chineset: 'https://kb.benchmarkemail.com/cn/can-i-add-google-analytics-tracking-to-my-email-campaigns/',
                    chinese: 'https://kb.benchmarkemail.com/tw/can-i-add-google-analytics-tracking-to-my-email-campaigns/',
                    japanese: 'https://kb.benchmarkemail.com/jp/can-i-add-google-analytics-tracking-to-my-email-campaigns/',
                    italian: 'https://kb.benchmarkemail.com/it/posso-aggiungere-google-analytics-alla-mia-campagna-email/',
                    french: 'https://kb.benchmarkemail.com/fr/comment-ajouter-le-tracking-de-google-analytics-a-mes-campagnes-d-email/',
                    brazil: 'https://kb.benchmarkemail.com/br/posso-adicionar-o-monitoramento-do-google-analytics-nas-minhas-campanhas-de-email/',
                    german: 'https://kb.benchmarkemail.com/de/kann-ich-google-analytics-tracking-in-meine-e-mail-kampagnen-einfuegen/'
                }[lang || 'english'];

                // When it’s blank, we insert the email title (replace spaces with underlines)
                function initGoogleCampaign () {
                    if (!$scope.advancedEmailOptions.googleAnalyticsAllUrl) {
                        $scope.emailData.GoogleAnalyticsCampaign = '';
                    } else {
                        $scope.emailData.GoogleAnalyticsCampaign = $scope.emailData.EmailName.replace(/ /g, '_');
                    }
                }

                $rootScope.summaries = {};

                let naturalElement = helpers.getNaturalId($rootScope.aElement.id);
                let emailDetailsPromises = [];

                // Get the ToListId and ToListName from email parent for assign to the new emails versions
                let listId = $rootScope.aElement.emailData.ToListId;
                let enableNode = false;
                let timezone;

                // Init email options for show every email details
                $scope.emailDetailsOptions = [];
                $scope.emailVersions = [];

                // Init for duplicate email
                $scope.duplicateModal = false;
                $scope.duplicateSettings = [];
                $scope.duplicateName = '';

                // Init default filter for create new automation email
                $scope.sortList = '-EmailTemplateCreatedDate';

                function initEmails () {
                    if ($scope.emailDetailsOptions.length === 0) {
                        // Get the activated email for this element ($scope.naturalId)
                        canvasService.getActiveEmails(naturalElement, $stateParams.canvasId).then((response) => {
                            // TODO This logic has to disappear when the BE response return the correct information
                            let draft = response.data.filter((draft) => draft.UIStatus === 1),
                                active = response.data.filter((active) => active.UIStatus === 2),
                                result = [];

                            if (active && active.length) {
                                result.push(active.pop());
                            }

                            if (draft && draft.length) {
                                result.push(draft[0]);
                            }

                            return result;
                        }).then((emails) => {
                            for (let i = 0, l = emails.length; i < l; i++) {
                                emailDetailsPromises.push(canvasService.getEmailDetails(emails[i].EmailId));

                                // Push every email
                                $scope.emailVersions.push(emails[i]);
                            }
                            return emailDetailsPromises;
                        }).then((emailDetails) => {
                            return $q.all(emailDetails);
                        }).then((details) => {
                            for (let i = 0, l = details.length; i < l; i++) {
                                $scope.emailDetailsOptions.push(details[i].data);

                                // We assign the email name to every version that comes from details
                                $scope.emailVersions[i].emailName = details[i].data.EmailName;
                                $scope.emailVersions[i].editor = details[i].data.Version;
                            }

                            // Assign the active email for show in the node
                            $scope.activeEmail = $scope.emailVersions.find(email => email.UIStatus === 2);
                            $rootScope.$emit('getActiveEmails', true);
                            enableNode = true;

                            // Client settings
                            return canvasService.getClientSettings();
                        }).then(function (settings) {
                            timezone = _.find(timezones, function(timezone) {
                                return timezone.value === settings.data.Response.TimeZone
                            });
                        }).catch((error) => {
                            console.log(error);
                        });
                    }
                }
                // Load emails list
                function loadEmailListAsync () {
                    if (!$rootScope.emailData) {
                        canvasService.getEmailList(0,5).success((data) => {
                            $rootScope.emailData = data.Results;
                            $scope.emailList = $rootScope.emailData;
                            $scope.setScrollLogic($scope.id);
                        });
                    } else {
                        $scope.emailList = $rootScope.emailData;
                        $scope.setScrollLogic($scope.id);
                    }
                }

                function loadTrashEmailListAsync() {
                    if(!$rootScope.trashList) {
                        canvasService.getTrashEmails().then(({data}) => {
                            $rootScope.trashList = data.Results;
                            $rootScope.trashCount = data.Results && data.Results.length || 0;
                        });
                    }
                };

                $scope.displaySearchInput = (show) => {
                    let input = document.getElementById ("search-email");
                    $scope.displaySearch = show;
                    $scope.search.email = '';

                    input.focus();
                };

                const checkPermissionReminder = () => {
                    if (!$scope.data.permisionReminder) {
                        return true;
                    }
                    else if ($scope.emailData.PermissionReminderMessage !== '') {
                        return true;
                    } else {
                        return false;
                    }
                };

                // Validate form email inputs
                function validateFields (status) {
                    let partialRes,
                        emailName = $scope.emailData.EmailName,
                        deferred = $q.defer();

                    if (!$scope.emailData.Subject ||
                        !emailName ||
                        !$scope.emailData.FromName ||
                        !$scope.emailData.FromEmail ||
                        !$scope.emailData.ReplyEmail) {

                        $rootScope.$emit('errorMsg', $scope.translate('canvas.error.601'));
                        $scope.sbjErr = ($scope.emailData.Subject === '');
                        $scope.eNameErr = (emailName === '');
                        $scope.eFromErr = ($scope.emailData.FromName === '');
                        $scope.eFromSubjErr = ($scope.emailData.FromEmail === '');
                        $scope.eFromReplyErr = ($scope.emailData.ReplyEmail === '');

                        partialRes = true;
                    }

                    if (checkPermissionReminder() ||
                        ($scope.advancedEmailOptions.googleAnalyticsAllUrl && !$scope.emailData.GoogleAnalyticsCampaign) ||
                        ($scope.advancedEmailOptions.pageTextTextarea && !$scope.emailData.InboxPreviewText)) {

                        $scope.permError = $scope.emailData.PermissionReminderMessage === '' && $scope.advancedEmailOptions.permisionReminder;
                        $scope.analyticsError = $scope.emailData.GoogleAnalyticsCampaign === '' && $scope.advancedEmailOptions.googleAnalyticsAllUrl;
                        $scope.pgTextError = $scope.emailData.InboxPreviewText  === '' && $scope.advancedEmailOptions.pageTextTextarea;

                        partialRes = $scope.analyticsError || $scope.permError || $scope.pgTextError || partialRes;
                    }

                    if (!partialRes) {
                        $scope.sbjErr = $scope.eNameErr = $scope.eFromErr = $scope.eFromSubjErr = $scope.eFromReplyErr = false;
                        $scope.permError = $scope.analyticsError = $scope.pgTextError = false;
                        if(status !== 'updateEmail') {
                            canvasService.validateDuplicateEmailName(emailName).success((res) => {
                                if (res.IsUniqueName) {
                                    $scope.eNameErr = false;
                                    $scope.storedEmailName = emailName;
                                    $scope.emailChanged = false;
                                    deferred.resolve();
                                } else {
                                    $rootScope.$emit('errorMsg',$scope.translate('canvas.action.sendEmail.duplicateEmailName'));
                                    $scope.eNameErr = true;
                                    deferred.reject();
                                }
                            }).error((err) => {
                                let error = err.Message || $scope.translate('canvas.error.601');
                                //Error msg from backend when failing
                                $rootScope.$emit('errorMsg', error);
                                $scope.eNameErr = true;
                                deferred.reject();
                            });
                        } else {
                            deferred.resolve();
                        }
                    } else {
                        deferred.reject();
                    }

                    return deferred.promise;
                }

                // extending translate method, this method not available on isolate scope
                $scope.translate = $rootScope.translate;

                $scope.advancedOptionsTitle = true;

                // Init email address list for select
                if (!$rootScope.userEmailAddress) {
                    canvasService.getUserEmailAddress().success((data) => {
                        $rootScope.userEmailAddress = data.Results || [];
                        $scope.emailAddressList = $rootScope.userEmailAddress.map((obj) => {
                            return obj.Email;
                        });
                    });
                }

                // Init emails options
                initEmails();

                $scope.showEmailOptions = () => {
                    $scope.emailOptionsAvailable = true;
                };

                $scope.chooseEmailOption = (option) => {
                    $scope.emailOption = option;
                    $scope.emailOptionsAvailable = false;
                };

                $scope.isCopyAndEdit = false;
                $scope.showDuplicateModal = () => {
                    Intercom('trackEvent', 'AP - NewEmailVersion');
                    let modalTemplate = $templateCache.get('actions/send-email-modal'),
                        modalContent;

                    //Create template and compile it
                    if(!$('.modal-email-form-' + $scope.connections.id).length) {
                        modalContent = $compile(modalTemplate)($scope);
                        $('body').append(modalContent);
                    }

                    $scope.isCopyAndEdit = true;
                    $scope.modalWindow = true;
                    $scope.duplicateModal = true;
                };

                // Show Email Modal (Automation Email)
                $scope.showSendEmailModal = () => {
                    Intercom('trackEvent', 'AP - NewEmailVersion');
                    let modalTemplate = $templateCache.get('actions/send-email-modal'),
                        modalContent;

                    //Create template and compile it
                    if(!$('.modal-email-form-' + $scope.connections.id).length) {
                        modalContent = $compile(modalTemplate)($scope);
                        $('body').append(modalContent);
                    }

                    // Init variables for reuse modal
                    $scope.modalWindow = true;
                    $scope.selectedView = false;
                    $scope.search = {};

                    loadEmailListAsync();
                    loadTrashEmailListAsync();

                    // Get values from selects
                    if (!$rootScope.userEmailAddress) {
                        canvasService.getUserEmailAddress().success((data) => {
                            $rootScope.userEmailAddress = data.Results || [];
                            $scope.emailAddressList = $rootScope.userEmailAddress.map((obj) => {
                                return obj.Email;
                            });
                        });
                    }

                    // Search functionality Email Modal (Automation Email)
                    $scope.search.search = (val) => {
                        if (val && val.length > 0 && !$scope.searching) {
                            $scope.searching = true;
                            canvasService.searchEmails(val).then((res) => {
                                $scope.searching = false;
                                $scope.emailList = res.data.Results;
                            }).catch(() => {
                                $scope.searching = false;
                            });
                        } else {
                            $scope.emailList = $rootScope.emailData;
                        }
                    };
                };

                // Create new automation email
                $scope.createNew = () => {
                    $scope.selectedView = true;
                    $scope.showAddSendEmailModal = true;
                    $scope.displayEmailForm = true;
                    $scope.displayList = true;
                    $scope.showEmailVersions = false;
                    $scope.modalWindow = false;
                    $scope.emailOptionsAvailable = false;
                    $scope.isEditable = true;

                    $scope.mergeTags = helpers.getMergeTags($rootScope.loaderData);

                    // Init new email data (First view)
                    $scope.emailData = {
                        Subject: '',
                        EmailName: '',
                        FromName: $rootScope.emptyEmail.FromName,
                        FromEmail: $rootScope.emptyEmail.FromEmail,
                        ReplyEmail:  $rootScope.emptyEmail.ReplyEmail,
                        GoogleAnalyticsCampaign: '',
                        PermissionReminderMessage: $rootScope.emptyEmail.PermissionReminderMessage,
                        WebpageVersion: true,
                        TemplateContent: '',
                        InboxPreviewText: ''
                    };

                    if(!$scope.mergeTags.length) {
                        $scope.showTagDefault = true;
                        $scope.emailData.ToListId = '';
                        $scope.emailData.ToListName = '';
                    } else if($scope.emailData && !$scope.emailData.ToListId) {
                        $scope.emailData.ToListId = $scope.mergeTags[0].id;
                    } else {
                        $scope.emailData.ToListId = $scope.emailData.ToListId + '';
                    }

                    // Init Advanced Email Options (Second view)
                    $scope.advancedEmailOptions ={
                        pageTextTextarea: false,
                        googleAnalyticsAllUrl: false,
                        editorType: '',
                        permisionReminder: true
                    }
                };

                $scope.$watch('emailData.ToListId', (value) => {
                    if ($scope.mergeTags) {
                        $scope.emailData.ToListName = $scope.mergeTags.find((tag) => tag.id === value).name;
                    }
                });

                // Reuse existing automation email
                $scope.insertExisting = function (emailId, fromEditor, emailName = 'Copy') {
                    $scope.isFromEditor = fromEditor;
                    $scope.currentDuplicateEmailId = emailId;
                    $scope.duplicateName = emailName + ' Copy';
                    $scope.duplicateModal = !$scope.duplicateModal;
                    canvasService.generateThumbs(emailId).then(() => {});
                };

                // Scroll for get more results
                $scope.setScrollLogic = (id) => {
                    $scope.emailListLoader = false;
                    angular.element(document.getElementById('listEmailContainer' + id)).bind("scroll", () => {
                        if (!$scope.emailListLoader && !$rootScope.stopLoadingEmailList && !$scope.search.email) {
                            $scope.emailListLoader = true;
                            canvasService.getEmailList($rootScope.emailListOffset, 5).success((data) => {
                                if (!data.Results.length) {
                                    $rootScope.stopLoadingEmailList = true;
                                } else {
                                    $rootScope.emailListOffset++;
                                    $rootScope.emailData = _.uniqBy($rootScope.emailData.concat(data.Results), 'EmailTemplateId');
                                    $scope.emailList = $rootScope.emailData;
                                }
                                $scope.emailListLoader = false;
                            }).error(() => {
                                $scope.emailListLoader = false;
                            })
                        }
                    });
                };

                let inProcess = false;
                $scope.moveToTrash = (eId) => {
                    if(!inProcess) {
                        inProcess = true;
                        canvasService.trashEmail(eId).then(() => {
                            const index = $rootScope.emailData.findIndex((i) => i.EmailTemplateId == eId);
                            const splicedEl = $rootScope.emailData.splice(index, 1);
                            $scope.emailList = $rootScope.emailData;

                            delete splicedEl.$$hashKey;
                            $rootScope.trashList.unshift(splicedEl[0]);
                            $rootScope.trashCount ++;
                        }).finally(() => {
                            inProcess = false;
                        });
                    }
                };

                $scope.restoreEmail = (eId) => {
                    if(!inProcess) {
                        inProcess = true;
                        canvasService.restoreTrashEmail(eId).then(() => {
                            const index = $rootScope.trashList.findIndex((i) => i.EmailTemplateId == eId);
                            const splicedEl = $rootScope.trashList.splice(index, 1);
                            $rootScope.trashCount --;

                            delete splicedEl.$$hashKey;
                            $rootScope.emailData.unshift(splicedEl[0]);
                            $scope.emailList = $rootScope.emailData;
                        }).finally(() => {
                            inProcess = false;
                        });
                    }
                };

                $scope.listView = true;
                $scope.toggleEmailsView = (display) => {
                    $scope.listView = display;
                };

                $scope.validClickingArea = () => {
                    $scope.contMenu = 0;
                };

                // Hide Email Modal (Automation Email)
                $scope.hideModal = () => {
                    $scope.modalWindow = false;
                    $scope.displayList = false;
                    $scope.selectedView = true;
                    $rootScope.$emit('displayExtraVeil', false);
                    $rootScope.$emit('hideActionSendEmailModal');
                    if($scope.search) {
                        $scope.search.email = '';
                    }
                    $scope.emailList = $rootScope.emailData;
                };

                // Save new duplicate email
                $scope.saveDuplicate = () => {
                    let payload, emailCreated;

                    if ($scope.duplicateName) {
                        $scope.duplicateError = false;
                        $scope.didReuse = false;
                        $scope.reuse = false;
                        $scope.duplicating = true;

                        // Validate that email name does not exist
                        canvasService.validateDuplicateEmailName($scope.duplicateName).then((response) => {
                            if (response.data.IsUniqueName) {
                                // Create new payload
                                payload = {
                                    EmailName: $scope.duplicateName,
                                    JourneyId: $stateParams.canvasId,
                                    JourneyVersion: 1,
                                    ElementId: $scope.naturalId
                                };

                                // Create new email draft
                                return canvasService.createDuplicateActivated(payload, $scope.currentDuplicateEmailId);
                            } else {
                                // This response does not return a fail for catch the error we need to reject
                                return $q.reject($scope.translate('canvas.action.sendEmail.duplicateEmailName'));
                            }
                        }).then(({data}) => {
                            emailCreated = data;
                            // Create email versions
                            return canvasService.getActiveEmails($scope.naturalId, $stateParams.canvasId);
                        }).then((emails) => {
                            // TODO This logic has to disappear when the BE response return the correct information
                            let draft = emails.data.filter((draft) => draft.UIStatus === 1),
                                active = emails.data.filter((active) => active.UIStatus === 2);

                            $scope.emailVersions = [];

                            if (active && active.length) {
                                $scope.emailVersions.push(active.pop());
                            }

                            if (draft && draft.length) {
                                $scope.emailVersions.push(draft[0]);
                            }

                            // Assign new values to array of version and details
                            $scope.emailDetailsOptions.push(emailCreated);

                            // Assign the name of the email to every version
                            for (let i = 0, l = $scope.emailVersions.length; i < l; i++) {
                                $scope.emailDetailsOptions[i].Id = $scope.emailVersions[i].EmailId;
                                $scope.emailVersions[i].emailName = $scope.emailDetailsOptions[i].EmailName;
                                $scope.emailVersions[i].editor = $scope.emailDetailsOptions[i].Version;
                                canvasService.generateThumbs($scope.emailVersions[i].EmailId).then(() => {});
                            }

                            $scope.duplicating = false;
                            $scope.didReuse = true;
                            $scope.reuse = true;
                            $scope.duplicateName = '';
                            $scope.duplicateModal = !$scope.duplicateModal;
                            $rootScope.$emit('displayExtraVeil', false);
                            $scope.hideModal();
                        }).catch((error) => {
                            $rootScope.$emit('errorMsg', error);
                            $scope.duplicateName = '';
                            $scope.duplicating = false;
                        });
                    } else {
                        $scope.duplicateError = true;
                    }
                };

                // Close option for reuse email
                $scope.cancelDuplicate = ()  => {
                    $scope.duplicateModal = !$scope.duplicateModal;

                    if($scope.isCopyAndEdit) {
                        $scope.isCopyAndEdit = false;
                        $scope.modalWindow = false;
                        $scope.displayList = false;
                        $scope.selectedView = true;
                    }
                };

                $scope.copyEmail = (emailId, emailName) => {
                    $scope.isFromEditor = true;
                    $scope.currentDuplicateEmailId = emailId;
                    $scope.duplicateName = emailName + ' Copy';
                    $scope.showDuplicateModal();
                };

                // Save new email function
                $scope.save = () => {
                    let status = 'fromEmail';
                    if($scope.emailData.Id) {
                        status = 'updateEmail';
                    }

                    validateFields(status).then(() => {
                        if (status === 'updateEmail') {
                            // this is an update email action
                            canvasService
                                .updateEmailData($scope.emailData.Id, $scope.emailData)
                                .success((id) => {
                                    if (id) {
                                        $timeout(function() {
                                            $scope.cancel();
                                        }, 100);
                                    }
                                });
                        } else {
                            $scope.editorSubMenu = true;
                            $scope.displayList = false;
                        }
                    }).catch(() => {
                        let errors = {
                            sbjErr: $scope.sbjErr,
                            eNameErr: $scope.eNameErr,
                            eFromErr: $scope.eFromErr,
                            eFromSubjErr: $scope.eFromSubjErr,
                            eFromReplyErr: $scope.eFromReplyErr,
                            permError: $scope.permError,
                            analyticsError: $scope.analyticsError,
                            pgTextError: $scope.pgTextError
                        };

                        $rootScope.$emit('displayActionSendEmailModalError', errors);
                    });
                };

                $scope.switcher = function (type) {
                    switch (type) {
                        case 'permisionReminder':
                            $scope.advancedEmailOptions.permisionReminder = !$scope.advancedEmailOptions.permisionReminder;
                            if ($scope.advancedEmailOptions.permisionReminder) {
                                let orgName = ($rootScope.cSettings) ? $rootScope.cSettings.ClientCompany : '';
                                $scope.emailData.PermissionReminderMessage = $scope.translate('canvas.action.sendEmail.permisionReminder1') + orgName + $scope.translate('canvas.action.sendEmail.permisionReminder2');
                            } else {
                                $scope.emailData.PermissionReminderMessage = '';
                            }
                            break;
                        case 'webPageVersion':
                            $scope.emailData.WebpageVersion = !$scope.emailData.WebpageVersion;
                            break;
                        case 'previewText':
                            $scope.advancedEmailOptions.pageTextTextarea = !$scope.advancedEmailOptions.pageTextTextarea;
                            break;
                        case 'googleAnalyticsAllUrl':
                            $scope.advancedEmailOptions.googleAnalyticsAllUrl = !$scope.advancedEmailOptions.googleAnalyticsAllUrl;
                            initGoogleCampaign();
                            break;
                    }
                };

                $rootScope.$on('activeRedirectTo', (event, type,  fromDetails, designLink) => {
                    let _onError = (err) => {
                        //Error msg from backend when failing
                        if(helpers.getJourneyFirstList() == '11111111') {
                            $rootScope.$emit('errorMsg', $scope.translate('canvas.error.613'));
                        } else {
                            $rootScope.$emit('errorMsg', err.Message);
                        }

                        //Close loader
                        $rootScope.$emit('jbLoader', false);

                        //When fail we open the list and show another error mesg
                        $scope.displayList = true;
                    };

                    let _next = () => {
                        canvasService.redirectToEditor($scope.emailData.Version, $scope.advancedEmailOptions.emailId, $stateParams.canvasId);
                    };

                    if (type) {
                        $rootScope.$emit('jbLoader', true);

                        if (fromDetails) {
                            _next();
                        } else {
                            let journeyPayload,
                                payload;

                            journeyPayload = {
                                JourneyId: $stateParams.canvasId,
                                JourneyVersion: 1,
                                ElementId: $scope.naturalId
                            };

                            $scope.emailData.Version = canvasService.getVersionByType(type);

                            // Dummy email bullet proof
                            if($scope.emailData.ToListId === '11111111'){
                                $scope.emailData.ToListId = 0;
                            }

                            payload = angular.merge($scope.emailData, journeyPayload);

                            canvasService.createDraftEmail(payload).then((response) => {
                                angular.merge($scope.emailData, payload);
                                $scope.advancedEmailOptions.emailId = response.data;
                                _next();
                            }).catch(_onError);
                        }
                    }
                });

                $scope.parseEmailTitle = function (desc, limit) {
                    if (desc) {
                        if ( desc.length > limit) {
                            desc = desc.slice(0, limit) + '...';
                        }
                    }

                    return desc;
                };

                $scope.parseDescription = function (desc) {
                    var textToParse = desc;

                    if (desc) {
                        if ( textToParse.length > 15) {
                            textToParse = textToParse.slice(0, 15) + '...';
                            //Desc < 15
                        }  else if (textToParse.length < 15) {
                            textToParse = textToParse;
                        }
                    } else {
                        textToParse = 'Description';
                    }

                    return textToParse;
                };

                $scope.getListName = function() {
                    return $scope.emailData.ToListName || $rootScope.segmentSelected || $rootScope.listSelected || '';
                };

                $scope.selectedCancel = function () {
                    $scope.selectedView = false
                };

                $scope.config = function (evt) {
                    if (!enableNode) {
                        return;
                    }
                    var type = 'displayList';
                    if ($scope.data.emailId) {
                        $scope[type] = false;
                        type = 'selectedView';
                    }

                    if ((!$rootScope.isSibligNodeOpen && !$scope[type]) || ($rootScope.isSibligNodeOpen && $scope[type])) {
                        if ($scope.editorSubMenu) {
                            $scope.editorSubMenu = false;
                            $scope.displayList = true;
                            $scope.selectedView = false;

                            if($scope.data.emailId) {
                                $scope.data.emailStatus = 'updateEmail';
                            } else {
                                $scope.data.emailStatus = 'createNew';
                            }
                        } else {
                            //Show form menu
                            $scope[type] = !$scope[type];

                            // Detect when a sibling element is open
                            if ($scope[type]) {
                                $rootScope.isSibligNodeOpen = true;
                                $rootScope.siblingEmailName = $scope.activeEmail.emailName;
                            } else {
                                $rootScope.isSibligNodeOpen = false;
                            }

                            // add z-index to canvas to avoid elements overlap
                            if(type === 'selectedView') {
                                $rootScope.$emit('zIndex', $scope[type]);
                            }
                        }
                        $scope.displaySubMenu = false;
                    }
                };

                $scope.showDetails = function (id, status) {
                    $scope.displayList = true;
                    $scope.selectedView = true;
                    $scope.modalWindow = false;
                    $scope.editorSubMenu = false;
                    $scope.mergeTags = [];

                    // Find email d ata base on id
                    $scope.emailData = $scope.emailDetailsOptions.find(email => parseInt(email.Id) === id);

                    $scope.mergeTags.push({
                        id: $scope.emailData.ToListId,
                        name: $scope.emailData.ToListName
                    });

                    $scope.advancedEmailOptions = {
                        pageTextTextarea: $scope.emailData.InboxPreviewText !== '',
                        googleAnalyticsAllUrl: $scope.emailData.GoogleAnalyticsCampaign !== '',
                        permisionReminder: $scope.emailData.PermissionReminderMessage !== ''
                    };

                    if(status === 1) {
                        $scope.isEditable = true;
                    }

                    if(status === 2) {
                        $scope.isEditable = false;
                    }
                };

                // when the design button is clicked
                $scope.sendToEditor = (editor, emailId) => {
                    canvasService.redirectToEditor(editor, emailId, $stateParams.canvasId);
                };

                $scope.reportsView = true;
                $scope.showReport = (emailName) => {
                    Intercom('trackEvent', 'AP - EmailReport');
                    $rootScope.$emit('summary', true, $stateParams.canvasId, $rootScope.currentJBTitle, emailName);
                };

                $scope.showVersions = ($event) => {
                    $event.stopPropagation();
                    $scope.isVersionsAvailable = !$scope.isVersionsAvailable;
                };

                //Cancel Button
                $scope.cancel = function () {
                    $scope.displayList = false;

                    // Put merge tags null if the user go back to versions
                    $scope.mergeTags = null;
                };

                // Close all modals
                $scope.close = function () {
                    $scope.displayList = false;
                    $scope.selectedView = false;

                    $rootScope.isSibligNodeOpen = false;

                    // add z-index to canvas to avoid elements overlap
                    $rootScope.$emit('zIndex', $scope['selectedView']);
                };

                // Functionality for show make active draft modal
                $scope.activeDraftModal = (id) => {
                    $scope.showActiveDraftModal = true;
                    $scope.selectedView = false;
                    $scope.displayList = false;
                    $scope.editorSubMenu = false;
                    $scope.draftEmailId = id;
                };

                // Hide make active draft modal
                $scope.hideActiveDraftModal = () => {
                    $scope.showActiveDraftModal = false;
                    $scope.selectedView = true;
                    $scope.displayList = false;
                    $scope.editorSubMenu = false;
                };

                // Call event for active draft email
                $scope.activeDraft = () => {
                    $rootScope.$emit('activeDraftEmail');
                };

                // Active draft email event
                $rootScope.$on('activeDraftEmail', () => {
                    if ($scope.draftEmailId) {
                        let email = $scope.emailVersions.find(email => email.EmailId === $scope.draftEmailId),
                            payload;

                        payload = {
                            JourneyId: email.JourneyId,
                            JourneyVersion: email.JourneyVersion,
                            ElementId: $scope.naturalId
                        };
                        $scope.loadingActivateDraft = true;
                        canvasService.activeDraftEmail(payload, email.Vertsion).then(() => {
                            // Change the status of the draft email to active and assign last update new date
                            email.UIStatus = 2;
                            email.ActivationDate = new Date();

                            // Filter emails
                            $scope.emailVersions = $scope.emailVersions.filter(email => email.EmailId === $scope.draftEmailId);
                            $scope.emailDetailsOptions = $scope.emailDetailsOptions.filter(email => parseInt(email.Id) === $scope.draftEmailId);

                            // Assign new value to active email to the node
                            $scope.activeEmail = $scope.emailVersions.find(email => email.UIStatus === 2);
                            $rootScope.siblingEmailName = $scope.activeEmail.emailName;

                            // Execute listener to get the email versions, when a email its activated
                            $rootScope.$emit('getActiveEmails', true);
                            Intercom('trackEvent', 'AP - ActivateEmail');

                            $scope.showActiveDraftModal = false;
                            $scope.selectedView = true;
                            $scope.displayList = false;
                            $scope.editorSubMenu = false;
                            $scope.draftEmailId = null;
                            $scope.loadingActivateDraft = false;
                        }).catch((error) => {
                            $scope.loadingActivateDraft = false;
                        });
                    }
                });

                // Functionality for show delete draft modal
                $scope.deleteDraftModal = (id) => {
                    // The modal its outside this view we need to attach to root the variable
                    $scope.$root.showDeleteDraftModal = true;
                    $scope.draftEmailId = id;
                    $scope.displayList = false;
                    $scope.selectedView = false;
                };

                // Hide delete draft email modal
                $scope.$root.hideDeleteDraftModal = () => {
                    $scope.$root.showDeleteDraftModal = false;
                    $scope.$root.displayList = true;
                    $scope.selectedView = true;
                };

                // Call event for delete draft email
                $scope.$root.deleteDraft = () => {
                    $rootScope.$emit('deleteDraftEmail');
                    $timeout(() => {
                        $scope.$root.displayList = true;
                        $scope.selectedView = true;
                    }, 500);
                };

                // Delete draft email
                $rootScope.$on('deleteDraftEmail', () => {
                    if ($scope.draftEmailId) {
                        let email = $scope.emailVersions.find(email => email.EmailId === $scope.draftEmailId),
                            payload;

                        payload = {
                            JourneyId: email.JourneyId,
                            JourneyVersion: email.JourneyVersion,
                            ElementId: $scope.naturalId
                        };

                        canvasService.deleteDraftEmail(payload, email.Vertsion).then(() => {
                            $scope.emailVersions = $scope.emailVersions.filter(email => email.EmailId !== $scope.draftEmailId);
                            $scope.emailDetailsOptions = $scope.emailDetailsOptions.filter(email => parseInt(email.Id) !== $scope.draftEmailId);
                            $scope.$root.showDeleteDraftModal = false;
                            $scope.draftEmailId = null;
                        }).catch((error) => {
                            console.log(error);
                        });
                    }
                });

                $scope.previewEmail = function (emailId) {
                    $scope.isPreviewOpen = true;
                    $scope.displayList = false;
                    $scope.selectedView = false;

                    $rootScope.$emit('previewEmail', '', '', '', $scope.id);
                    $("#dvPreviewContent").html("<div class=\"loading-animation\"><span></span><span></span><span></span><span></span></div>");
                    canvasService.getPreview(emailId)
                        .then(function({data}) {
                            if (data.Response.ID) {
                                var obj = data.Response;
                                var content = obj.TemplateContent;
                                if (content.indexOf("<!-- /Footer Path -->") != -1) {
                                    content = content.substring(0, content.indexOf("<!-- /Footer Path -->"));
                                }
                                $("#dvPreviewContent").html("");
                                var iframe = document.createElement('iframe');
                                $(iframe).attr("id", "ifrPreviewContent");
                                $("div#dvPreviewContent").append(iframe);
                                iframe.contentWindow.document.open();
                                iframe.contentWindow.document.write(content);
                                iframe.contentWindow.document.close();
                            } else {
                                alert("Could not load Preview");
                            }
                        });
                };

                // Get the active emails of every node
                $rootScope.$on('getActiveEmails', (evt, doEmit) => {
                    if(doEmit) {
                        let active = $scope.emailVersions.find(email => email.UIStatus === 2);

                        $rootScope.summaries[$scope.naturalId] = {
                            emailId: active.EmailId,
                            emailName: active.emailName,
                            elementId: $scope.naturalId
                        };

                        $rootScope.$emit('newActiveEmail' + $scope.naturalId, $rootScope.summaries[$scope.naturalId]);
                    }
                });

                // Default value for editor
                $scope.editor = 'dad';

                $scope.redirectTo = function(id) {
                    $rootScope.$emit('activeRedirectTo', id);
                    $scope.editorSubMenu = false;
                };

                $scope.editorSwitcher = (editor) => {
                    $scope.editor = editor;
                };

                $scope.hideEditorModal = () => {
                    $scope.editorSubMenu = false;
                };

                $scope.sortBy = function(val) {
                    $scope.sortList = val;
                };

                $scope.toggleEmojiModal = () => {
                    $scope.displayEmojiModal = !$scope.displayEmojiModal;
                    $scope.selectedView = !$scope.selectedView;
                    $scope.displayList = !$scope.displayList;
                };
            }],
            link: function (scope, elem, attr) {
                if ($rootScope.aElement) {
                    // bullet proving multiple targets
                    if (document.getElementById($rootScope.aElement.id)) {
                        delete $rootScope.aElement;
                        return false;
                    }

                    // load template
                    var template = $templateCache.get('active_templates/actions/active-send-email');
                    var modalTemplate = $templateCache.get('active_templates/actions/active-send-email-modal');
                    scope.connections = scope.connections || {};
                    scope.left = $rootScope.aElement.left;
                    scope.top = $rootScope.aElement.top;
                    scope.id = $rootScope.aElement.id;
                    scope.connections.id = scope.id;
                    scope.naturalId = helpers.getNaturalId(scope.id);
                    scope.color = $rootScope.aElement.color;
                    scope.type = $rootScope.aElement.type;
                    scope.data = $rootScope.aElement.data;
                    scope.numbers = '0';
                    scope.summaries = [];
                    $rootScope.canvasHasEmailNode = true;
                    delete $rootScope.aElement;

                    //Create template and compile it
                    var content = $compile(template)(scope);
                    $('.canvas').append(content);
                    var modalContent = $compile(modalTemplate)(scope);
                    $('body').append(modalContent);

                    $rootScope.$on('syncEmoji', function (evt, emojiVal) {
                        if(scope.emailData) {
                            scope.emailData.Subject = emojiVal;
                        }
                    });

                    $rootScope.$on('syncEmojiPreviewText', function (evt, emojiVal) {
                        if(scope.emailData) {
                            scope.emailData.InboxPreviewText = emojiVal;
                        }
                    });

                    initSubjectLinePicker(`subject-line-picker-container-${scope.id}`, canvasService, $rootScope.translate, (syncVal) => {
                        if(scope.emailData) {
                            scope.emailData.Subject = syncVal;
                            $('#delay-modal .modal-body').scrollTop(0);
                        }
                    });


                    $rootScope.$on('reporter_' + $rootScope.currentAPId + scope.id, function(evt, data) {
                        if(data) {
                            scope.numbers = data;
                        }
                    });

                    // Close the preview email modal and change the z-index
                    $rootScope.$on('closePreviewEmail' + scope.id, () => {
                        scope.isPreviewOpen = false;
                        scope.displayList = false;
                        scope.selectedView = true;
                    });
                }

                // Listener for close versions dropdown of reports
                $document.on('click', function (event) {
                    event.stopPropagation();
                    if (scope.isVersionsAvailable) {
                        scope.$apply(() => {
                            scope.isVersionsAvailable = false
                        });
                    }
                });
            }
        };
    }
}());



// WEBPACK FOOTER //
// ./app/directives/canvas_active_directives/actions/active-send-email-action.js